export var LinkType;
(function (LinkType) {
    LinkType["Direct"] = "direct";
    LinkType["Conditional"] = "conditional";
    LinkType["Random"] = "random";
    LinkType["Remote"] = "remote";
})(LinkType || (LinkType = {}));
export { LinkType as Type };
export default LinkType;
//# sourceMappingURL=Type.js.map